// extracted by mini-css-extract-plugin
export default {"container":"GhostTile_container__RukiO","bottom":"GhostTile_bottom__4Ealr"};